module.exports = __webpack_public_path__ + "img/chijieban7.4609669d.jpg";